<div class="row">
  <div class="col" style="text-align: center; font-size: 30px;">
    Sale List
  </div>
  <div class="col-2" style="text-align: right;" (click)="closeClicked()">
    <button mat-button style="background: red; color: white;">Close</button>
  </div>
</div><br>
<div *ngIf="is_data_available">
  <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
  </mat-progress-spinner>
</div>
<div class="row">
  <div class="col">
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Delivery Date</th>
          <th>Order First Created</th>
          <th>Order Last Modified</th>
          <th>Final Order Value</th>
          <th>Amount Paid</th>
          <th>Difference</th>
          <th>Amount Trace</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of product_data; let product_index=index">
          <td>{{ product_index + 1 }}</td>
          <td>{{ data['delivery_date'] | date: 'dd-MM-yyyy' }}</td>
          <td>{{ data['time_created'] | date: 'dd-MM-yyyy, h:mm a' }}</td>
          <td>{{ data['time_modified'] | date: 'dd-MM-yyyy, h:mm a' }}</td>
          <td>{{ data['final_order_value'] | currency: 'INR' }}</td>
          <td>{{ data['total_amount_paid'] | currency: 'INR' }}</td>
          <td>{{ data['difference'] | currency: 'INR' }}</td>
          <td>
            <table>
              <tbody>
                <tr *ngFor="let order of data['transaction_details']">
                  <td style="border: none;">{{ order['scope'] }}</td>
                  <td style="border: none;">{{ order['rid'] }}</td>
                  <td style="border: none;">{{ order['amount']| currency: 'INR' }}</td>
                  <td style="border: none;">@{{ order['time_created'] | date: 'h:mm a' }}</td>
                </tr>
                <td>Total</td>
                <td colspan="2">{{ data['total'] | currency: 'INR'}}</td>
              </tbody>
            </table>
          </td>
      </tbody>
    </table>
  </div>
</div>
